import React, { useEffect, useState } from "react";
import queryString from "query-string";
import history from "../../history";
import * as util from "../Helpers/Util";
import getImzaciSecimKural from "../../services/getImzaciSecimKural";
import muellifKullaniciListesi from "../../services/muellifKullaniciListesi";
import {
  Card,
  Row,
  Col,
  message,
  Spin,
  Form,
  Select,
  Button,
  Tooltip as TooltipAnd,
  FormGroup,
  Input
} from "antd";
import CreateBasvuruImzaciList from "../../services/createBasvuruImzaciList";

const { Option } = Select;

const parsed = queryString.parse(history.location.search);

const layout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
    md: {
      span: 8,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
    md: {
      span: 12,
    },
    lg: {
      span: 12,
    },
  },
};

const formItemStyle = {
  marginLeft: 10,
};

const TableId = {
  EbMuellifBuro: 1,
  SistemKullanici: 2,
};

const ImzaciSecimForm = () => {
  const [spining, setSpining] = useState(true);
  const [form] = Form.useForm();
  const [imzaciList, setImzaciList] = useState([]);

  const load = async () => {
   await getImzaciSecimKural(parsed.altSurecTipiId, parsed.parentBasvuruId)
      .then(async (resp) => {
        if (resp.data.success) {
          let data = resp.data.result;
          setImzaciList(data);
          // default value değerleri form fields da null dönüyor  
          await data.map(async (d) => {
            if (d.tabloId == TableId.EbMuellifBuro && d.muellifBuroId != null) {       
                form.setFieldsValue({ ["imzaciBuro-" + d.objectid]: d.muellifBuroId });
                if(d.kullaniciId != null){
                    form.setFieldsValue({ ["imzaciKullanici-" + d.objectid]: d.kullaniciId }); 
                }
            }else if(d.tabloId == TableId.SistemKullanici && d.kullaniciId != null){
                form.setFieldsValue({ ["imzaciKullanici-" + d.objectid]: d.kullaniciId });
            }
          });

        } else {
          util.errorMessage(resp.data.message);
        }
      })
      .catch((ex) => {
        util.errorMessage(String(ex.message));
      });
    setSpining(false);
  };

  useEffect(() => {
    load();
  }, []);

  const onFinish = async (e) => {
    setSpining(true);
    let formValues = form.getFieldValue();
    let formField = {
        basvuruAnaId : parsed.parentBasvuruId,
        basvuruImzaciList : []
    };
   
    if(Object.keys(formValues).length == 0){
        message.warning("Güncellenecek müellif bulunamamıştır.");
    }else{
        await Object.keys(formValues).map(key =>{
            let data = { }
            const part = key.split("-");  

            let imzaciIndex = formField.basvuruImzaciList.findIndex(item => item.imzaciId == parseInt(part[1]));
            if(imzaciIndex != -1){
                if( key.indexOf("imzaciKullanici") == 0 && formValues[key] != null ){ 
                    formField.basvuruImzaciList[imzaciIndex].kullaniciId = parseInt(formValues[key]);           
                } else if( key.indexOf("imzaciBuro") == 0 ){
                    formField.basvuruImzaciList[imzaciIndex].muellifBuroId = parseInt(formValues[key]);
                }
            }
            else if( key.indexOf("imzaciKullanici") == 0 && formValues[key] != null ){                    
                data.imzaciId = parseInt(part[1]);
                data.kullaniciId = parseInt(formValues[key]);
                formField.basvuruImzaciList.push(data);
            } else if( key.indexOf("imzaciBuro") == 0 ){
                data.imzaciId = parseInt(part[1]);
                data.muellifBuroId = parseInt(formValues[key]);
                formField.basvuruImzaciList.push(data);
            }
            
           
        });

        if(formField != null){
            CreateBasvuruImzaciList(formField).then(res => { 
                if(res.data.success){
                    message.success('İşlem başarı ile tamamlandı.');
                    setSpining(false);
                    window.parent.location.reload(); 
                }else{
                    message.error(res.data.message);
                    setSpining(false);
                }})
            .catch(ex => {
                setSpining(false);
            });
        }
        console.log(formField);
    }
    
    setSpining(false);
  };


  const onChangeByMuellif = async (key, objectId) => {
    form.setFieldsValue({ ["imzaciKullanici-" + objectId]: null });
    setSpining(true);

    await muellifKullaniciListesi(key).then((resp) => {
      if (resp.data.success) {
        if (resp.data.result.length == 0) {
          message.warning("Büronun aktif kullanıcısı bulunmamaktadır.");
        }
        imzaciList.map((imzaList) => {
          if (objectId == imzaList.objectid) {
            imzaList.buroUserList = resp.data.result;
          }
        });
      } else {
        message.error(resp.data.message);
      }
    });
    setSpining(false);
  };

  return (
    <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
      <Card
        bodyStyle={{
          padding: "10",
          fontWeight: "bold",
        }}
      >
        İmzacı Seçim Form
      </Card>
      <Card
        bodyStyle={{
          padding: "10",
          color: "red",
        }}
      >
        NOT : Kullanıcı yoksa yoksa lütfen e-devlet le sisteme giriş yapmasını
        isteyin.
      </Card>
      <Form form={form} onFinish={onFinish} {...layout}>
        {imzaciList.map((list) => (
          <Card bodyStyle={{ padding: "10" }}>
            {list.tabloId == TableId.SistemKullanici && (
              <>
                <Form.Item
                  key={list.objectid}
                  label={list.adi}
                  name={"imzaciKullanici-" + list.objectid}
                  style={formItemStyle}
                  labelAlign="left"
                >
                  <Select
                    showSearch
                    defaultValue={list.kullaniciId}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {list.imzaciList &&
                      list.imzaciList.map((bt) => (
                        <Option key={bt.objectid} value={bt.objectid}>
                          {bt.adi}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </>
            )}
            {list.tabloId == TableId.EbMuellifBuro && (
             <>
                <Form.Item
                  key={list.objectid}
                  label={list.adi}
                  name={"imzaciBuro-" + list.objectid}
                  style={formItemStyle}
                  labelAlign="left"
                >
                  <Select
                    showSearch
                    defaultValue={list.muellifBuroId}
                    key={list.objectid}
                    onChange={(el) => onChangeByMuellif(el, list.objectid)}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={list.isReadonly}
                  >
                    {list.imzaciList &&
                      list.imzaciList.map((bt) => (
                        <Option key={bt.objectid} value={bt.objectid}>
                          {bt.adi}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                {list.buroUserList &&
                  <Form.Item
                    key={"imzaciKullanici-" + list.objectid}
                    name={"imzaciKullanici-" + list.objectid}
                    label= {list.adi + " Büro Kullanıcı"}
                    style={formItemStyle}
                    labelAlign="left"
                  >
                    <Select
                      showSearch
                      defaultValue={list.kullaniciId}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {list.buroUserList &&
                        list.buroUserList.map((bt) => (
                          <Option
                            key={bt.kullanici.kullaniciId}
                            value={bt.kullanici.kullaniciId}
                          >
                            {bt.kullanici.adsoyad}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                }
              </>
            )}
          </Card>
        ))}
        <Row>
          <Col span={20} style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              Kaydet
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default ImzaciSecimForm;
